/* v23 Homepage Fixes - Tara Sartoria */
(function() {
  function init() {
    try {
      var heroSection = document.getElementById('shopify-section-image_banner');
      if (heroSection) {
        heroSection.addEventListener('click', function(e) {
          if (e.target.closest('a, button')) return;
          window.location.href = '/collections/best-sellers';
        });
      }
      var multiSections = ['multicolumn_Umx3w8', 'multicolumn_ar8JwT', 'multicolumn_eCnM3N'];
      multiSections.forEach(function(id) {
        var sec = document.getElementById('shopify-section-' + id);
        if (!sec) return;
        sec.querySelectorAll('.multicolumn-card').forEach(function(card) {
          var link = card.querySelector('a[href]');
          var img = card.querySelector('.multicolumn-card__image-wrapper');
          if (!link || !img) return;
          var href = link.getAttribute('href');
          img.addEventListener('click', function() { window.location.href = href; });
        });
      });
    } catch (err) { console.error('v23 homepage fixes error:', err); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

(function() {
  function initConsolidated() {
    try {
      var alreadyImg = document.querySelector('img[src*="PJNAM_TAU_XD_02"]');
      if (alreadyImg) {
        var alreadySection = alreadyImg.closest('.shopify-section');
        if (alreadySection) {
          alreadySection.addEventListener('click', function(e) {
            if (e.target.closest('a, button')) return;
            window.location.href = '/collections/new-arrivals-1';
          });
          alreadySection.style.cursor = 'pointer';
        }
      }
      var summerImg = document.querySelector('img[src*="SUMMER-COLLECTION-HERO-3000x1500"]');
      if (summerImg) {
        var summerSection = summerImg.closest('.shopify-section');
        if (summerSection) {
          summerSection.addEventListener('click', function(e) {
            if (e.target.closest('a, button')) return;
            window.location.href = '/collections/summer-collection';
          });
          summerSection.style.cursor = 'pointer';
        }
      }
      var xmasImg = document.querySelector('img[src*="v1-AMZ-AD-KI_NGAN_HON_H-ST-VAL_copy"]');
      if (xmasImg) {
        var media = xmasImg.closest('.banner__media');
        if (media && media.parentElement) {
          var wrapper = media.parentElement;
          var overlay = wrapper.querySelector('.banner__content');
          if (overlay) {
            overlay.addEventListener('click', function() { window.location.href = '/collections/silk-robes-kimonos'; });
            overlay.style.cursor = 'pointer';
          }
        }
      }
      /* SILK FOR TWO: click on lifestyle image => /collections/gifts-for-couples */
      var silkForTwoImg = document.querySelector('img[src*="lifestyle-Cedric-Anna-2026Sep17"]');
      if (silkForTwoImg) {
        var silkForTwoSection = silkForTwoImg.closest('.shopify-section');
        if (silkForTwoSection) {
          silkForTwoSection.addEventListener('click', function(e) {
            if (e.target.closest('a, button')) return;
            window.location.href = '/collections/gifts-for-couples';
          });
          silkForTwoSection.style.cursor = 'pointer';
        }
      }
    } catch (err) { console.error('v23 consolidated handlers error:', err); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initConsolidated); } else { initConsolidated(); }
})();
